import script from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=ca1f0000&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca1f0000"]])

export default __exports__